/**
 * The two full-page moves the console's session and error handling make: leave for another address
 * (the signed-out page), and load this page again (a stale build). One module, so a spec can
 * replace it: jsdom does not implement navigation.
 */

export function leaveFor(href: string): void {
  window.location.assign(href)
}

export function reloadPage(): void {
  window.location.reload()
}
